import React, { FC } from "react";
import greenDot from "../../../../../assets/greenDot.svg";
import greyDot from "../../../../../assets/greyDot.svg";
import "./SellOption.scss";
const SellOption: FC<{
  title: string;
  isActive: boolean;
  tooltip?: boolean;
  imageUrl?: { logo: any };
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  handleClick: () => void;
}> = ({
  title,
  isActive,
  tooltip,
  imageUrl,
  handleClick,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  return (
    <div className="sell-option__wrapper">
      <div
        onClick={handleClick}
        className={`${
          isActive ? "sell-option sell-option--active" : "sell-option"
        }`}
      >
        <div>
          <img src={isActive ? greenDot : greyDot} />

          <p>
            {title}{" "}
            {tooltip && (
              <span
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                What's this?
              </span>
            )}
          </p>
        </div>
        {imageUrl && <imageUrl.logo />}
      </div>
    </div>
  );
};

export default SellOption;
